import { api } from "@/lib/api";

const label = (value) => String(value || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
export const normalizeCategory = (item) => ({ id: item.id ?? item.value, label: item.label ?? label(item.id ?? item.value) });
export const normalizeTicket = (item) => ({
  id: item.id, subject: item.subject, description: item.description, category: item.category,
  status: item.status, submittedAt: item.submittedAt ?? item.submitted_at, stale: Boolean(item.stale),
  appointment: item.appointment ?? (item.showAppointmentDetails ? item.appointment : null),
  technicianName: item.showAppointmentDetails ? (item.technicianName ?? item.technician_name) : null,
  attachments: item.attachments ?? [], priority: item.priority,
});
const supportParams = (plantId) => plantId ? { plant_id: plantId } : {};
export const fetchCategories = async (plantId) => {
  const { data } = await api.get("/support/categories", { params: supportParams(plantId) });
  const items = Array.isArray(data) ? data : data.categories ?? data.items ?? [];
  return { categories: items.map(normalizeCategory), general: Boolean(data?.general), stub: Boolean(data?.stub ?? data?.mode === "stub") };
};
export const fetchDiagnosis = async (plantId, category) => (await api.get("/support/diagnosis", { params: { ...supportParams(plantId), category } })).data;
export const fetchArticles = async (plantId, category) => (await api.get("/support/articles", { params: { ...supportParams(plantId), category } })).data;
export const fetchTickets = async (plantId) => (await api.get("/support/tickets", { params: supportParams(plantId) })).data.map(normalizeTicket);
export const fetchTicket = async (plantId, ticketId) => normalizeTicket((await api.get(`/support/tickets/${ticketId}`, { params: supportParams(plantId) })).data);
export const createTicket = async ({ plantId, category, description, hazards, files, contact, window, preferences, requestId }) => {
  const form = new FormData();
  if (plantId) form.append("plant_id", plantId);
  form.append("category", category); form.append("description", description);
  form.append("request_id", requestId ?? crypto.randomUUID());
  (hazards ?? []).forEach((hazard) => form.append("safety_hazards", hazard));
  (files ?? []).forEach((file) => form.append("files", file));
  if (contact) form.append("contact", contact);
  if (window) form.append("window", window);
  if (preferences) form.append("preferences", preferences);
  return normalizeTicket((await api.post("/support/tickets", form)).data);
};
export const cancelTicket = async ({ plantId, ticketId }) => normalizeTicket((await api.post(`/support/tickets/${ticketId}/cancel`, supportParams(plantId))).data);
